<template>
  <v-card tile>
    <v-card-title class="font-weight-black mt-5 text-uppercase">
      Resume
    </v-card-title>

    <v-divider role="presentation" class="mb-8"></v-divider>
    <v-text class="font-weight-black mt-5 mb-5 text-uppercase">
      Education
    </v-text>
    <h3 class="text-justify ml-4 body-2">
      <strong>B.S. - Computer Science; concentration in Cybersecurity</strong>
    </h3>
    <p class="text-justify ml-4 body-2">
      CSU Stanislaus, Spring 2022
    </p>
    <h3 class="text-justify ml-4 body-2">
      <strong>A.S. - Computer Science</strong>
    </h3>
    <p class="text-justify ml-4 body-2">Modesto Junior College, 2019</p>
    <h3 class="text-justify ml-4 body-2">
      <strong>Certificate - Programming Specialist</strong>
    </h3>
    <p class="text-justify ml-4 body-2">Modesto Junior College, 2019</p>

    <v-text class="font-weight-black mt-5 mb-5 text-uppercase">
      Awards &amp; Honors
    </v-text>
    <h3 class="text-justify ml-4 mr-4 body-2"><strong>Dean's List</strong></h3>
    <p class="text-justify ml-4 mr-4 body-2">CSU Stanislaus, Spring 2020</p>
    <p class="text-justify ml-4 mr-4 body-2">
      "In recognition of superior academic achievement for maintaining a 3.5 or
      higher GPA."
    </p>

    <v-text class="font-weight-black mt-5 mb-5 text-uppercase">
      Related Courses
    </v-text>
    <br />
    <p class="text-justify ml-4 mr-4 mt-5 body-2">
      Data Structures &amp; Algorithms &bull; Computer Organization &bull; Human
      Centered Design &bull; UNIX/Linux Systems
    </p>
    <p class="text-justify ml-4 mr-4 body-2">
      Script Programming for the Web &bull; Discrete Structures &bull; Problem
      Solving/Programming 1 &amp; 2
    </p>
    <p class="text-justify ml-4 mr-4 body-2">
      Assembly Language Programming &amp; Architecture &bull; Database
      Management Systems
    </p>
    <p class="text-justify ml-4 mr-4 body-2">
      Automata &bull; Coding &amp; Information Theory &bull; Android Development
      &bull; Operating Systems
    </p>
    <p class="text-justify ml-4 mr-4 body-2">
      Cybersecurity Fundamentals &bull; Programming Languages &bull;
      Communication Networking
    </p>

    <v-text class="font-weight-black mt-5 mb-5 text-uppercase">
      Skills
    </v-text>

    <div class="text-center">
      <br />
      Windows, Powershell, Microsoft Defender, Microsoft Sentinel, Active
      Directory, JavaScript
    </div>
    <br />
    <v-text class="font-weight-black mt-5 mb-5 text-uppercase">
      Work Experience
    </v-text>

    <h3 class="text-justify ml-4 mr-4 body-2">
      <strong>Automotive Technician</strong>
    </h3>
    <pre
      class="text-justify ml-4 mr-4 body-2"
    ><p>Infinite Auto Tech, LLC &bull; San Jose, Ca     4/2012 - 1/2016</p></pre>
    <pre
      class="text-justify ml-4 mr-4 body-2"
    ><p>Barbershop Racing &bull; Modesto, Ca            6/2006 - 1/2012</p></pre>
    <p class="text-justify ml-4 mr-4 body-2">
      Specialized in high performance modifications and general repair for Audi,
      VW, BMW, and Honda vehicles.
    </p>
    <v-flex class="d-flex justify-start mt-8">
      <v-btn icon href="https://github.com/rizingson" target="_blank">
        <v-icon class="pa-2">mdi-github</v-icon>
      </v-btn>

      <v-btn
        icon
        href="https://www.facebook.com/damon.bonner.33"
        target="_blank"
      >
        <v-icon class="pa-2">mdi-facebook</v-icon>
      </v-btn>

      <v-btn
        icon
        href="https://www.instagram.com/rizing_son/?hl=en"
        target="_blank"
      >
        <v-icon class="pa-2">mdi-instagram</v-icon>
      </v-btn>

      <v-btn
        icon
        href="https://www.linkedin.com/in/damon-bonner-9a5579178/"
        target="_blank"
      >
        <v-icon class="pa-2">mdi-linkedin</v-icon>
      </v-btn>

      <v-btn icon href="mailto: damonjbonner@gmail.com">
        <v-icon class="pa-2">mdi-email</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: "Resume"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-progress-circular {
  margin: 1rem;
}
</style>
